import styled from 'styled-components'

const Day = styled.div`
  padding: 16px 20px 0;

  @media screen and (min-width: 500px) {
    padding: 16px 5.8vw 0;
  }

  @media screen and (min-width: 960px) {
    padding: 0 0 0 60px;
  }

  h2 {
    margin: 0;
    padding-left: 18px;
    font-family: 'freight-sans-condensed-pro', sans-serif;
    font-size: 22px;
    font-size: 1.375rem;
    text-transform: uppercase;
    font-weight: 700;
    position: relative;
    color: #114b89;

    @media screen and (min-width: 600px) {
      padding-left: 34px;
      font-size: 34px;
      font-size: 2.125rem;
    }

    span {
      display: block;
      font-family: 'freight-text-pro', serif;
      font-size: 38px;
      font-size: 2.375rem;
      font-weight: 600;
      line-height: 0.75;

      @media screen and (min-width: 600px) {
        font-size: 48px;
        font-size: 3rem;
      }
    }

    &::before {
      content: '';
      background-color: #d3d335;
      width: 10px;
      height: 48px;
      position: absolute;
      left: 0;
      top: 4px;

      @media screen and (min-width: 600px) {
        width: 15px;
        height: 70px;
        top: 8px;
      }
    }
  }

  h4 {
    font-family: 'freight-sans-condensed-pro', sans-serif;
    font-size: 22px;
    font-size: 1.375rem;
    text-transform: uppercase;
    font-weight: 700;
    color: #114b89;
    margin-top: 24px;
    margin-bottom: 13px;

    @media screen and (min-width: 600px) {
      font-size: 34px;
      font-size: 2.125rem;
      margin-top: 33px;
      margin-bottom: 20px;
    }
  }

  > p {
    border-top: 2px solid #bdbdbd;
    margin-top: 13px;
    font-size: 20px;
    font-size: 1.25rem;
    color: black;
    font-weight: 500;
    padding-top: 20px;

    @media screen and (min-width: 600px) {
      margin-top: 25px;
      font-size: 26px;
      font-size: 1.625rem;
    }
  }

  ul {
    margin: 13px 0 0;
    padding: 0;
    list-style: none;

    @media screen and (min-width: 600px) {
      margin: 25px 0 0;
    }

    li:last-of-type {
      padding-bottom: 0;
    }
  }

  .event-card {
    display: block;
    border-top: 2px solid #bdbdbd;

    p {
      margin: 0;
      font-size: 18px;
      font-size: 1.25rem;
      font-weight: 500;

      @media screen and (min-width: 600px) {
        font-size: 26px;
        font-size: 1.625rem;
      }

      &:last-of-type {
        margin-bottom: 14px;
      }
    }
  }
`

export default Day
